var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "queue-popup-wrap" }, [
    _vm.userInfo.fpid && _vm.popupList.length
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPopup,
                expression: "showPopup",
              },
            ],
            staticClass: "popup-body",
          },
          [
            _vm._l(_vm.popupList, function (item, index) {
              return [
                item.name
                  ? _c(item.name, {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index === 0 && _vm.showPopup,
                          expression: "index === 0 && showPopup",
                        },
                      ],
                      key: item.name,
                      tag: "component",
                      attrs: {
                        "is-show": index === 0 && _vm.showPopup,
                        options: item.options || {},
                      },
                      on: { closed: _vm.showNext, delPopup: _vm.delPopup },
                    })
                  : _vm._e(),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }